<div class="icon-container">
  <app-icon class="icon-icon" [icon]="type === 'pinned' ? 'pin' : 'info'" [width]="16" />
</div>
<div class="message">
  <span class="message-title">{{ message.profile.name }}</span>
  <span class="message-content" [innerHtml]="content | name | chatEmote : 1000"></span>
</div>
